import { AnchorButton } from '@kmx/legos-react-button';
import AccordionItem from '@shared/components/AccordionItem';
import { ReactElement } from 'react';

import { FAQItem, getFAQData } from '../../services/faq-service';
import { SectionContentProvider } from '../SectionContentProvider';

export default function FAQ() {
    const ListingItem = ({ question, answer, orderNo }: FAQItem): ReactElement => {
        return (
            <AccordionItem title={question}>
                <p dangerouslySetInnerHTML={{ __html: answer }} />
            </AccordionItem>
        );
    };

    return (
        <section className="desktop-wrapper" id="faq">
            <div className="m-t-xl m-b-xl p-t-xl mdc-layout-grid__inner desktop-wrapper">
                <div className="m-b-0 mdc-layout-grid__cell mdc-layout-grid__cell--span-1" />
                <div className="m-b-0 mdc-layout-grid__cell mdc-layout-grid__cell--span-10">
                    <h3 className="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 kmx-typography--display-4 text-centered m-0">
                        {' '}
                        Frequently asked questions
                    </h3>
                    <SectionContentProvider get={getFAQData} type="FAQ">
                        <ListingItem question="" answer="" orderNo={0} />
                    </SectionContentProvider>
                </div>
                <div className="m-b-0 mdc-layout-grid__cell mdc-layout-grid__cell--span-1" />
                <h3 className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 kmx-typography--display-4 text-centered m-t-2xl">
                    {' '}
                    Still have questions?
                </h3>
                <div className="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 text-centered m-b-xl">
                    <AnchorButton
                        href={process.env.AUCTIONS_HOMEPAGE_URL + '/contactus.aspx'}
                        level="primary">
                        <span className="primary-1">Contact Us</span>
                    </AnchorButton>
                </div>
            </div>
        </section>
    );
}
